// extracted by mini-css-extract-plugin
export var search = "QuickSearch-module--search--36FHz";
export var searchPreHeader = "QuickSearch-module--search-pre-header--3JApu";
export var searchHeader = "QuickSearch-module--search-header--2breX";
export var searchContent = "QuickSearch-module--search-content--dwjTi";
export var searchLinks = "QuickSearch-module--search-links--1izVd";
export var searchBtn = "QuickSearch-module--search-btn--eBkXl";